import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'sorting-header',
  templateUrl: './sorting-header.component.html',
  styleUrls: ['./sorting-header.component.scss']
})
export class SortingHeaderComponent implements OnInit {
  @Input() property:string;
  @Input() currentProperty:string;
  @Input() currentDirection:string;
  @Output() sortAsc = new EventEmitter();
  @Output() sortDesc = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  get ascActive():boolean {
    return this.currentProperty === this.property && this.currentDirection === 'asc';
  }

  get descActive():boolean {
    return this.currentProperty === this.property && this.currentDirection === 'desc';
  }

  public sortAscArrow() {
    this.sortAsc.emit(this.property);
  }

  public sortDescArrow() {
    this.sortDesc.emit(this.property);
  }

}
